// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Description-module--cls1--YhUKd","cls2":"styles-Description-module--cls2--35gue styles-Description-module--cls1--YhUKd"};